import axios from "axios";
import { Constants } from "../utils/Constants";

export function getDataTable(events) {
    return axios.post(`${Constants.baseUrl}/associado/list`, events);
}

export function create(form) {
    return axios.post(`${Constants.baseUrl}/associado`, form);
}

export function get(id) {
    return axios.get(`${Constants.baseUrl}/associado/${id}`);
}

export function update(form, id) {
    return axios.post(`${Constants.baseUrl}/associado/${id}`, form);
}

export function getSimpleList(data) {
    return axios.get(`${Constants.baseUrl}/associado/simpleList`, { params: data });
}
